// extracted by mini-css-extract-plugin
export var divider = "_r1-0";
export var systemMessage = "_r1-1";
export var systemMessageWrapper = "_r1-2";